export default __webpack_public_path__ + "static/media/hand-gun-blk.6ba87339.svg";